import React, { Component } from 'react';
import { Button, Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
export default class Icon extends Component {
  constructor(props) {
    super(props);
    this.toggle = () => this.setState(prevState => ({
      tooltipOpen: !prevState.tooltipOpen
    }));
    this.state = {
      tooltipOpen: false
    };
  }
  render() {
    const id = this.props.id;
    return /*#__PURE__*/React.createElement("div", {
      className: "input-group-append"
    }, /*#__PURE__*/React.createElement(Button, {
      id: "Tooltip-".concat(id),
      onClick: false,
      type: "button",
      color: "info"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      color: "#fff",
      icon: faInfo,
      size: this.props.size || '1x'
    })), /*#__PURE__*/React.createElement(Tooltip, {
      placement: "top",
      isOpen: this.state.tooltipOpen,
      target: "Tooltip-".concat(id),
      toggle: this.toggle
    }, this.props.text));
  }
}